import { useParams } from 'react-router';
import { DetailHeader, Section, KeyValueGrid } from '../components/DetailSection';
import { useGetUser } from '../api/useGetUser';
import { formatKobo } from '../lib/money';
import { formatDate } from '../lib/date';

export const GuestDetail = () => {
  const { uid = '' } = useParams();
  const { data, isLoading, isError } = useGetUser(uid);
  const user = data?.payload ?? null;

  if (isLoading) return <div className="text-sm text-gray-500">Loading...</div>;

  if (isError || !user) {
    return (
      <div className="flex flex-col gap-6 max-w-3xl">
        <DetailHeader backTo="/guests" backLabel="Members" title="Member" />
        <p className="text-sm text-red-500">Failed to load member.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 max-w-3xl">
      <DetailHeader backTo="/guests" backLabel="Members" title={`${user.first_name} ${user.last_name}`} />
      <Section title="Profile">
        <KeyValueGrid
          items={[
            { label: 'Email', value: user.email },
            { label: 'Phone', value: user.phone },
            { label: 'Date of birth', value: user.dob ? formatDate(user.dob) : '—' },
            { label: 'Gender', value: user.gender ? <span className="capitalize">{user.gender}</span> : '—' },
          ]}
        />
      </Section>
      <Section title="Bank">
        <KeyValueGrid
          items={[
            { label: 'Account number', value: user.account_number || '—' },
            { label: 'Bank name', value: user.bank_name || '—' },
            { label: 'Bank code', value: user.bank_code || '—' },
          ]}
        />
      </Section>
      <Section title="Wallet">
        <KeyValueGrid
          items={[
            { label: 'Balance', value: formatKobo(user.balance) },
            { label: 'Currency', value: user.currency },
            { label: 'Locale', value: user.locale },
          ]}
        />
      </Section>
    </div>
  );
};
